import React, { useState } from "react";
import { Container, Button, Card, Spinner, ListGroup, Badge } from "react-bootstrap";
import { checkout } from "../api";
import "./Checkout.css";

export default function Checkout({ cart = [], cartId }) {
  const [loading, setLoading] = useState(false);

  const totalItems = cart.reduce((sum, i) => sum + i.quantity, 0);
  const totalPrice = cart.reduce((sum, i) => sum + i.unit_price * i.quantity, 0);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const res = await checkout(cartId, {
        taxRate: 0.15,
        shippingFee: 99,
      });
      alert(`✅ Order placed successfully! Order ID: ${res.order_id}`);
    } catch (err) {
      alert("❌ Checkout failed: " + err.message);
    }
    setLoading(false);
  };

  return (
    <Container className="checkout-container mt-4">
      <Card className="checkout-card bg-dark text-light p-4">
        <h2 className="checkout-title mb-4">Checkout</h2>

        {cart.length === 0 ? (
          <div className="text-muted text-center py-4">Your cart is empty.</div>
        ) : (
          <>
            <ListGroup variant="flush" className="mb-3">
              {cart.map(item => (
                <ListGroup.Item
                  key={item.product_id}
                  className="bg-dark text-light d-flex justify-content-between align-items-center"
                >
                  <div>
                    {item.name}{" "}
                    <Badge bg="warning" text="dark">
                      x{item.quantity}
                    </Badge>
                  </div>
                  <div className="fw-bold text-success">
                    R {(item.unit_price * item.quantity).toFixed(2)}
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>

            <div className="checkout-summary mb-3">
              <p className="mb-1">
                Total items: <span className="text-warning fw-bold">{totalItems}</span>
              </p>
              <p>
                Total price:{" "}
                <span className="text-success fw-bold">R {totalPrice.toFixed(2)}</span>
              </p>
            </div>
          </>
        )}

        <Button
          variant="warning"
          className="checkout-btn"
          disabled={cart.length === 0 || loading}
          onClick={handleCheckout}
        >
          {loading ? <Spinner animation="border" size="sm" /> : "Place Order"}
        </Button>
      </Card>
    </Container>
  );
}